import DOMPurify from 'dompurify';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AccordionItemHeading, AccordionItemButton, AccordionItemPanel } from 'react-accessible-accordion';

import Actions from './props/Actions';
import constants from '../../../constants';
import { AttachmentList } from '../../../components/Attachments';
import { setActiveActivityBox } from '../../../store/Activities/index';

const Email = (props) => {
    let { activity, activityData, onUpdateActivity } = props;

    const dispatch = useDispatch();
    const { singlePageData } = useSelector(state => state['SinglePage']);

    let [hovered, setHovered] = useState(false);

    const handleReply = (e) => {
        e.stopPropagation();
        const replyTo = activity?.['direction'] === 'inbound' ? (activity?.['metadata']?.['from'] || '') : (activity?.['metadata']?.['to'] || '');
        const originalSubject = activity?.['metadata']?.['subject'] || activity?.emailSubject || activity?.title?.replace('Email: ', '') || '';
        const replySubject = originalSubject.startsWith('Re:') ? originalSubject : `Re: ${originalSubject}`;

        const schema = constants.getObjectSchema(singlePageData?.['objectType']);
        const associations = schema ? { [schema['plural']]: [singlePageData['_id']] } : { contacts: singlePageData?.['_id'] ? [singlePageData['_id']] : [] };

        dispatch(setActiveActivityBox({
            activityBox: 'email',
            associations,
            emailReplyData: {
                mode: 'reply',
                to: replyTo,
                subject: replySubject,
                body: `<br/><br/><div style="border-left: 2px solid #ccc; padding-left: 10px; margin-left: 5px; color: #666;">
                    <p><strong>On ${activityData?.createdAt}, ${activity?.direction === 'inbound' ? activity?.metadata?.from : activityData?.createdBy} wrote:</strong></p>
                    ${activity?.description || ''}
                </div>`,
                threadId: activity?.metadata?.threadId || null,
                inReplyTo: activity?.metadata?.internetMessageId || activity?.metadata?.messageId || null
            }
        }));
    };

    const handleForward = (e) => {
        e.stopPropagation();
        const originalSubject = activity?.metadata?.subject || activity?.emailSubject || activity?.title?.replace('Email: ', '') || '';
        const fwdSubject = originalSubject.startsWith('Fwd:') ? originalSubject : `Fwd: ${originalSubject}`;
        const fromInfo = activity?.direction === 'inbound' ? activity?.metadata?.from : activityData?.createdBy;
        const toInfo = activity?.direction === 'inbound' ? activityData?.createdBy : activity?.metadata?.to;

        const fwdSchema = constants.getObjectSchema(singlePageData?.objectType);
        const fwdAssociations = fwdSchema ? { [fwdSchema.plural]: [singlePageData['_id']] } : { contacts: singlePageData?.['_id'] ? [singlePageData['_id']] : [] };
        dispatch(setActiveActivityBox({
            activityBox: 'email',
            associations: fwdAssociations,
            emailReplyData: {
                mode: 'forward',
                to: '',
                subject: fwdSubject,
                body: `<br/><br/><div style="border-left: 2px solid #ccc; padding-left: 10px; margin-left: 5px; color: #666;">
                    <p>---------- Forwarded message ----------</p>
                    <p><strong>From:</strong> ${fromInfo || 'unknown'}</p>
                    <p><strong>To:</strong> ${toInfo || 'unknown'}</p>
                    <p><strong>Date:</strong> ${activityData?.createdAt}</p>
                    <p><strong>Subject:</strong> ${originalSubject}</p>
                    <br/>
                    ${activity?.description || ''}
                </div>`,
                threadId: null,
                inReplyTo: null
            }
        }));
    };

    return (
        <>
            <AccordionItemHeading>
                <AccordionItemButton>
                    <div className="activity-card email-card">
                        <div className="activity-header">
                            <div className="activity-type-info">
                                <div className="activity-icon email-icon">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <polyline points="22,6 12,13 2,6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <div className="activity-details">
                                    <div className="activity-title email-card-title">
                                        <span className="email-card-subject">
                                            {(activity?.emailSubject || activity?.title || 'Email sent').replace(/^Email:\s*/i, '')}
                                        </span>
                                        <span className="email-card-direction">
                                            {activity?.direction === 'inbound' ? 'incoming' : 'outgoing'}
                                        </span>
                                    </div>
                                    <div className="activity-meta">
                                        {activity?.metadata?.from && (
                                            <span className="created-by">from {activity.metadata.from}</span>
                                        )}
                                        {activity?.metadata?.to && (
                                            <span className="recipient">to {activity.metadata.to}</span>
                                        )}

                                        <div className="activity-badges">
                                            {activity?.metadata?.source && (() => {
                                                const meta = getSourceBadgePalette(activity.metadata.source);
                                                return (
                                                    <span className="activity-card-source" style={{
                                                        color: '#6c757d',
                                                        fontSize: '11px',
                                                        fontWeight: 500,
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        gap: '4px'
                                                    }}>
                                                        <i className={meta.icon} style={{ fontSize: '10px' }}></i>
                                                        {meta.label}
                                                    </span>
                                                );
                                            })()}
                                        </div>
                                    </div>
                                </div>
                            </div>



                            <div className="activity-actions" onClick={(e) => e.stopPropagation()}>
                                <Actions {...props} extraItems={[
                                    { label: 'Reply', icon: 'fa fa-reply', onClick: handleReply },
                                    { label: 'Forward', icon: 'fa fa-share', onClick: handleForward }
                                ]} />
                                <span className="activity-time">{activityData?.createdAt}</span>
                            </div>
                        </div>

                        {activity?.description && (
                            <div className="activity-card-preview">{stripHtml(activity.description)}</div>
                        )}
                    </div>
                </AccordionItemButton>
            </AccordionItemHeading>

            <AccordionItemPanel>
                <div className="activity-card-body email-card">
                    {activity?.description && (
                        <div className="activity-description" dangerouslySetInnerHTML={{ __html: sanitizeEmailHtml(activity.description) }}></div>
                    )}

                    {activity?.metadata?.workflowId && (
                        <div className="activity-metadata">
                            <div className="metadata-item">
                                <strong>Via Workflow</strong>
                                <span className="workflow-badge">Automated</span>
                            </div>
                        </div>
                    )}

                    {activity['attachments'] && activity['attachments'].length > 0 && (
                        <div className="activity-attachments" style={{ marginTop: '10px' }}>
                            <AttachmentList
                                attachments={activity['attachments']}
                                showUploadedBy={false}
                                enableActions={false}
                            />
                        </div>
                    )}
                </div>
            </AccordionItemPanel>
        </>
    );
};

// Strip scripts / event handlers / javascript: URLs / tracking-pixel-ish constructs
// from email HTML before rendering. Allowed schemes cover normal links + cid: inline images.
const sanitizeEmailHtml = (html) => DOMPurify.sanitize(html || '', {
    ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|cid):|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i,
    FORBID_TAGS: ['script', 'style', 'iframe', 'object', 'embed', 'meta'],
    FORBID_ATTR: ['onerror', 'onload', 'onclick']
});

const stripHtml = (html) => (html || '')
    .replace(/<style[\s\S]*?<\/style>/gi, '')
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/\s+/g, ' ')
    .trim();

// Small icon + label for the email source — no chip background, just a muted hint.
const getSourceBadgePalette = (source) => {
    if (source === 'manual') return { icon: 'fa fa-paper-plane', label: 'Manual' };
    if (source === 'inbound') return { icon: 'fa fa-inbox', label: 'Received' };
    return { icon: 'fa fa-cog', label: 'Workflow' };
};

export default Email;